/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddMediaPartnerAdvertiserRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {AddMediaPartnerAdvertiserResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const addMediaPartnerAdvertiser = (request: AddMediaPartnerAdvertiserRequest, options?: CashRequestOptions) => post<AddMediaPartnerAdvertiserRequest, AddMediaPartnerAdvertiserResponse>("/2.0/cash/add-media-partner-advertiser", request, {...options, rejectOnError: true })